var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/global-settings-drawer-panel.ts
import "@adornis/buildify/client/components/x-buildify-global-settings.js";
import "@adornis/buildify/client/components/x-buildify-size-picker.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { XDrawerPanel } from "@adornis/dialog/x-drawer-panel.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
var GlobalSettingsDrawerPanel = class extends XDrawerPanel {
  close() {
    super.close();
  }
  cancel() {
    this.close();
  }
  content() {
    return xComponents(html`
      <x-buildify-global-settings
        .globalSettingsClassName=${this.globalSettingsClassName}
        @close=${() => this.close()}
      ></x-buildify-global-settings>
    `);
  }
  static get element_name() {
    return "global-settings-drawer-panel";
  }
  styles() {
    return [
      ...super.styles(),
      {
        dialog: {
          //   width: 'min(700px, 100%) !important',
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], GlobalSettingsDrawerPanel.prototype, "globalSettingsClassName", 2);
GlobalSettingsDrawerPanel = __decorateClass([
  customElement("global-settings-drawer-panel")
], GlobalSettingsDrawerPanel);
export {
  GlobalSettingsDrawerPanel
};
